/**
 * An option for something like a dropdown, multiselect etc. Not much, but it helps when
 * we a) always name it "Option" (vs. Choice etc.) and b) always name the attributes as
 * value, label (vs. id, etc.).
 */
export type Option<T extends string | number = string> = {
  value: T;
  label: string;
};

export type OptionsSeparator = {
  value: "---";
  label: string;
};

export type IconOption<T extends string | number = string> = Option<T> & {
  icon?: React.ComponentType<{ className?: string }>;
};

export function formatOption<T extends string | number>(
  option: T,
  options: Option<T>[],
): string | undefined {
  const found = options.find((o) => o.value === option);
  return found?.label;
}

export function renderOptions<T extends string | number>(
  options: Option<T>[],
  opts: {
    empty?: boolean;
    nullable?: boolean;
    nullableLabel?: string;
  } = {},
) {
  const nodes = options.map((o) => (
    <option key={o.value} value={o.value}>
      {o.label}
    </option>
  ));

  const { empty, nullable } = opts;
  if (empty || nullable) {
    nodes.unshift(
      <option key="_empty_" value="" disabled={!nullable}>
        {opts.nullableLabel || "-"}
      </option>,
    );
  }
  return nodes;
}
